import { makeStyles } from '@material-ui/core';
var borderValue = '1px solid rgba(117, 117, 117, 0.3)';
export default makeStyles(function (theme) { return ({
    container: {
        border: borderValue,
        borderRadius: theme.spacing(1),
        display: 'flex',
        width: 'max-content',
        overflow: 'hidden',
    },
    option: {
        padding: theme.spacing(1, 2),
        cursor: 'pointer',
        color: '#757575',
        fontSize: theme.spacing(1.75),
        '&:not(:last-child)': {
            borderRight: borderValue,
        },
    },
    selectedOption: {
        backgroundColor: 'rgba(117, 117, 117, 0.12);',
        color: '#616161',
    },
}); });
